import type { DesignListItem } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { Link } from 'react-router';
import { MyDesignCard } from '@/entities/my-design';
import { storeCustomizeDesignPath } from '@/shared/config';

interface RecentDesignsProps {
  readonly designs: readonly DesignListItem[];
}

/** 최근 수정한 디자인 몇 개 — 판매 중인 상품이면 카드 아래에 "수정" 링크를 단다. */
export const RecentDesigns = ({ designs }: RecentDesignsProps): ReactElement => {
  if (designs.length === 0) {
    return <p className="py-6 text-sm text-muted-foreground">아직 저장한 디자인이 없어요.</p>;
  }

  return (
    <ul className="grid grid-cols-2 gap-x-4 gap-y-10 max-sm:[&>li:nth-child(3)]:hidden sm:grid-cols-3 sm:gap-x-6">
      {designs.map((design) => (
        <li key={design.id}>
          <MyDesignCard
            design={design}
            actions={
              design.productStatus === 'PUBLISHED' ? (
                <Link
                  to={storeCustomizeDesignPath(design.productId, design.id)}
                  aria-label={`${design.name} 수정`}
                  className="w-fit text-sm font-semibold underline underline-offset-4 hover:no-underline"
                >
                  수정
                </Link>
              ) : null
            }
          />
        </li>
      ))}
    </ul>
  );
};
